/**
 * wql
 * @description 作业记录管理
 * @Date 2020/10/31
 */
import React from 'react'
import {component_tool, framework_tool} from '../../../tool';
import {WizTableForm} from '../../common'
import moment from "moment";

const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1, isNotAuth: false}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1, isNotAuth: false}})
const labelConfig = WizTableForm.Config.label(this, {apiParams: {type: 12}})
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
let {WizModal} = component_tool;

//配置项
let componentName = 'homeworkRecord'


const templateConfig = (data) => {
  const {entityId,_this} = data;
  let columns =

    [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "标题",
        name: "name",
        dataIndex: "name",
        searchItem: {
          initialValue: entityId
        },
        tableItem: {}
      },
      {
        title: "提交人姓名",
        name: "fullName",
        dataIndex: "fullName",
        searchItem: {},
        tableItem: {}
      },
      {
        title: "提交人账号",
        name: "userName",
        dataIndex: "userName",
        searchItem: {},
        tableItem: {}
      },
      {
        title: "提交时间",
        name: "submitTime",
        dataIndex: "submitTime",
        tableItem: {}
      },
      {
        title: "组织",
        name: "orgId",
        searchItem: {
          diy: WizTableForm,
          ...organizationConfig,
          selectType: 'radio',
        }
      },
      {
        title: "组织名称",
        name: "orgName",
        dataIndex: "orgName",
        tableItem: {}
      },
      {
        title: "组织编码",
        name: "orgCode",
        dataIndex: "orgCode",
        tableItem: {}
      },
      {
        title: "岗位",
        name: "positionId",
        searchItem: {
          diy: WizTableForm,
          ...positionConfig,
          selectType: 'radio',
        }
      },
      {
        title: "岗位",
        name: "positionName",
        dataIndex: "positionName",
        tableItem: {}
      },
      {
        title: "是否通过",
        name: "pass",
        dataIndex: "pass",
        tableItem: {},
        searchItem: {
          type: 'select',
        },
        dict: [
          {code: 0, codeName: "未通过"},
          {code: 1, codeName: "通过"},
        ],
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        searchItem: {
          type: 'select',
        },
        dict: [
          {code: 0, codeName: "未提交"},
          {code: 1, codeName: "已提交"},
          {code: 2, codeName: "已批阅"},
        ],
      },
      {
        title: "提交类型",
        name: "orderType",
        dataIndex: "orderType",
        tableItem: {
          render: (text, record) => {
            if(record['order'] === 1) {
              return '首次提交';
            } else if(record['order'] > 1) {
              return '重复提交';
            } else {
              return ''
            }
          }
        },
        searchItem: {
          type: 'select',
        },
        dict: [
          {code: 0, codeName: "首次提交"},
          {code: 1, codeName: "重复提交"},
        ],
      },
      {
        title: "标签",
        name: "labelIds",
        dataIndex: "labelIds",
        searchItem: {
          ...labelConfig,
          diy: WizTableForm,
          selectType: 'radio',
        }
      },
      {
        title: "标签",
        name: "labelIds",
        dataIndex: "labelIds",
        width: 150,
        tableItem: {}
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        dict: [
          {code: 0, codeName: "未提交"},
          {code: 1, codeName: "已提交"},
          {code: 2, codeName: "已批阅"},
        ],
      },
      {
        title: "成绩",
        name: "score",
        dataIndex: "score",
        width: 150,
        tableItem: {},
      },
      {
        title: "评分人",
        name: "reviewerId",
        dataIndex: "reviewerName",
        searchItem: {
          ...userConfig,
          diy: WizTableForm,
          selectType: 'radio',
        },
      },
      {
        title: "评分人",
        name: "reviewerName",
        dataIndex: "reviewerName",
        tableItem: {}
      },
      {
        title: "当前评分人",
        name: "currentReviewerName",
        dataIndex: "currentReviewerName",
        tableItem: {}
      }
    ]


  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "openUrl"
              },

              formatParams: (rows, record, filters, callback) => {
                let id = record.id;
                let url = location.origin + '/#/homeworkRecord/homeworkRecordShow?recordId=' + id
                window.open(url, '_blank')
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return { disabled: record.state === 0 }
            },
            //     // window.open(location.origin + `/#/schedule/study?pid=${detail['id']}&sid=${id}`, id)
            //     window.open(location.origin + `/#/homeworkRecord/homeworkRecordShow?id=${id}`, id);
          }
        ]
      }
    }
  };
}

let reduxTemplateCofig = (args) => {
  const {entityId} = args;
  const apis = {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {name:entityId ? entityId : null}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {name:entityId ? entityId : null}
      }
    },
    check:{
      path: `${componentName}/reviewCheck`,
      payload: {
        key: `${componentName}@checkHandler`,
        apiParams: {}
      }
    }
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: false,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
